module.exports = __webpack_public_path__ + "img/duoshi.43518f53.png";